// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1fKFu","inputWrap":"CustomTip_inputWrap__2eytX"};